import type {
  ConversationLanguageCode,
  ConversationLanguageName,
} from 'lib-shared-languages';
import {
  conversationLanguages,
  defaultConversationLanguageCode,
} from 'lib-shared-languages';
import { useMemo } from 'react';

import { useServerStorage } from 'utils/useServerStorage';

export type PreferredLanguageValues = {
  /** The 2-letter language code used for the summary. Example: 'en', 'da' */
  readonly preferredLanguageCode?: ConversationLanguageCode;
  /** The full, human friendly, name of the language used for the summary */
  readonly preferredLanguage?: ConversationLanguageName;
};

export const useConversationPreferredLanguage = (): PreferredLanguageValues => {
  const { data } = useServerStorage('user');
  const { preferredLanguage: preferredLanguageCode } = {
    preferredLanguage: defaultConversationLanguageCode,
    ...data['agent_copilot'],
  };

  return useMemo(
    () => ({
      preferredLanguageCode,
      preferredLanguage:
        conversationLanguages.find(({ code }) => code === preferredLanguageCode)
          ?.name || undefined,
    }),
    [preferredLanguageCode],
  );
};
